/* The Locket Tree: keep asynchronously rendered BOLD option prices in the selected Doubly currency. */
(function (global) {
  'use strict';

  var document = global.document;
  var SELECTOR = '.bold_options span.money';
  var previous = global.TLTOptionCurrency;
  if (previous && typeof previous.destroy === 'function') previous.destroy();

  var active = false;
  var destroyed = false;
  var scheduled = null;
  var poll = null;
  var observer = null;

  function currencyApi() {
    var api = global.DoublyGlobalCurrency;
    if (!api || typeof api.convertAll !== 'function' || !/^[A-Z]{3}$/.test(api.currentCurrency || '')) return null;
    return api;
  }

  function observe() {
    if (active && observer && document.documentElement) {
      observer.observe(document.documentElement, {
        childList: true, subtree: true, characterData: true,
        attributes: true, attributeFilter: ['doubly-currency']
      });
    }
  }

  function stalePoundLabel(span, currency) {
    if (currency === 'GBP' || span.getAttribute('doubly-currency') !== currency) return false;
    var original = span.getAttribute('doubly-currency-gbp');
    if (original === null || !/^\d+(?:\.\d+)?$/.test(original)) return false;
    // A renderer can replace the text while retaining Doubly's "already converted"
    // marker. Repair only an explicit pound label equal to the cached source amount;
    // a different amount may be a real option-price change and must not be guessed.
    var match = String(span.textContent || '').trim().match(/^(?:£\s*|GBP\s+)((?:\d{1,3}(?:,\d{3})+|\d+)(?:\.\d{1,2})?)(?:\s+GBP)?$/);
    return !!match && Math.abs(Number(match[1].replace(/,/g, '')) * 100 - Number(original)) < 0.000001;
  }

  function sync() {
    scheduled = null;
    if (!active) return;
    var api = currencyApi();
    if (!api) return;
    var currency = api.currentCurrency;
    var spans = document.querySelectorAll(SELECTOR);
    var stale = Array.prototype.filter.call(spans, function (span) {
      return stalePoundLabel(span, currency);
    });
    var pending = Array.prototype.some.call(spans, function (span) {
      return span.getAttribute('doubly-currency') !== currency;
    });
    if (!pending && !stale.length) return;

    // Doubly owns the base amount, rounding and formatting. A selector prevents its
    // convertAll API from changing the global currency or cookie. Never edit option values.
    if (observer) observer.disconnect();
    try {
      stale.forEach(function (span) { span.removeAttribute('doubly-currency'); });
      api.convertAll(currency, SELECTOR);
    } catch (_error) {
      // Keep the app's original prices intact; later readiness/events can retry.
    } finally {
      observe();
    }
  }

  function schedule() {
    if (active && scheduled === null) scheduled = global.setTimeout(sync, 0);
  }

  function insideOptions(node) {
    if (!node) return false;
    var element = node.nodeType === 1 ? node : node.parentElement;
    return !!(element && element.closest && element.closest('.bold_options'));
  }

  function containsOptions(node) {
    return insideOptions(node) || !!(node && node.querySelector && node.querySelector('.bold_options'));
  }

  function changed(records) {
    var relevant = records.some(function (record) {
      if (record.type === 'attributes') return true; // The selected currency also appears on main-price spans.
      if (insideOptions(record.target)) return true;
      return Array.prototype.some.call(record.addedNodes || [], containsOptions);
    });
    if (relevant) schedule();
  }

  function changedInput(event) {
    var target = event.target;
    if (insideOptions(target) || (target && target.matches && target.matches('[name="doubly-currencies"]'))) schedule();
  }

  function pause() {
    active = false;
    if (scheduled !== null) global.clearTimeout(scheduled);
    if (poll !== null) global.clearInterval(poll);
    scheduled = poll = null;
    if (observer) observer.disconnect();
  }

  function start() {
    if (destroyed || active) return;
    active = true;
    if (!observer && typeof global.MutationObserver === 'function') observer = new global.MutationObserver(changed);
    observe();
    schedule();
    // Covers late app readiness and currency changes without a DOM event. The cheap
    // pending-span check avoids reformatting already converted prices.
    poll = global.setInterval(function () {
      if (document.visibilityState !== 'hidden') schedule();
    }, 1000);
  }

  function destroy() {
    destroyed = true;
    pause();
    document.removeEventListener('DOMContentLoaded', start);
    document.removeEventListener('shopify:section:load', schedule);
    document.removeEventListener('shopify:section:unload', schedule);
    document.removeEventListener('change', changedInput);
    document.removeEventListener('input', changedInput);
    global.removeEventListener('pagehide', pause);
    global.removeEventListener('pageshow', start);
  }

  document.addEventListener('shopify:section:load', schedule);
  document.addEventListener('shopify:section:unload', schedule);
  document.addEventListener('change', changedInput);
  document.addEventListener('input', changedInput);
  global.addEventListener('pagehide', pause);
  global.addEventListener('pageshow', start);
  global.TLTOptionCurrency = { destroy: destroy };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})(window);
